import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/registryPoints";
const listQuery = { orderby: ["id desc"] };

const getRegistryLogs = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery });
    return request(`${resource}/getLogs${query}`, { method: "GET" }, { countInHeaders: true });
};

const getCollectingTaskLogs = () => request(`${resource}/getCollectingTaskLogs`, { method: "GET" });

const getListForBid = (lon: number, lat: number) =>
    request(`${resource}/getListForBid?lon=${lon}&lat=${lat}`, { method: "GET" });

const startCollecting = (params: {}) => alertRequest(`${resource}/startCollecting`, body(params));

const resetCaches = () => alertRequest(`${resource}/resetCaches`, {});

export { getRegistryLogs, resetCaches, startCollecting, getCollectingTaskLogs, getListForBid };
